<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <ValidationObserver ref="mainForm" class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >First Name</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
                <input
                    id="firstName"
                    v-model="formValues.firstName"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Father Name</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
                <input
                    id="fatherName"
                    v-model="formValues.fatherName"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Grand Father Name</label
              >
              <validation-provider
                  v-slot="{ errors }"

                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
              }">
                <input
                    id="grandFatherName"
                    v-model="formValues.grandFatherName"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                "
              >Sex</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="Male"
                    v-model="formValues.sex"
                    class="my-3 ml-5"
                    type="radio"
                    value="Male"
                />
                <label for="Male"> Male </label>

                <input
                    id="Female"
                    v-model="formValues.sex"
                    class="my-3 ml-5"
                    type="radio"
                    value="Female"
                />
                <label for="Female"> Female </label>
                <br/>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 required">
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Date of Birth:
              </label>

              <validation-provider v-slot="{ errors }" rules="required">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    max-width="290px"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="formValues.dateOfBirth"
                        label="Birthday date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      ref="dateOfBirth"
                      v-model="formValues.dateOfBirth"
                      :max="maxBirthDate"
                      no-title
                      scrollable
                  ></v-date-picker>
                </v-menu>

                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >ID No.</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                    id="idNo"
                    v-model="formValues.idNo"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Education Program</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="programValue"
                    :elevation="1"
                    :items="EDUCATIONAL_PROGRAMS"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="name"
                    return-object
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Discipline</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="disciplineValue"
                    :elevation="1"
                    :items="DISCIPLINES"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="name"
                    return-object
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Level Of Study</label
              >
              <validation-provider v-slot="{ errors }" rules="required">
                <v-autocomplete
                    v-model="formValues.levelOfStudyId"
                    :elevation="1"
                    :items="LEVEL_OF_STUDIES"
                    :loading="lookupLoading"
                    dense
                    item-text="name"
                    item-value="id"
                    solo
                ></v-autocomplete>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Entry Year</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                  required: true,
                  generic_regex: '^[0-9]{4}$',
                  min_generic_value: 1950,
                  max_generic_value: new Date().getFullYear(),
                }"
              >
                <input
                    id="entryYear"
                    v-model="entryYearValue"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="number"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Proposed Year Of Graduation</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                  required: true,
                  generic_regex: '^[0-9]{4}$',
                }"
              >
                <input
                    id="proposedYearOfGraduation"
                    v-model="proposedYearValue"
                    :disabled="true"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="number"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Year Of Graduation</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                  generic_regex: '^[0-9]{4}$',
                  min_proposed_value: proposedYearValue,
                }"
              >
                <input
                    id="yearOfGraduation"
                    v-model="formValues.graduationYear"
                    :disabled="!entryYearValue"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="number"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
              <label
                  class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
              >Nationality</label
              >
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                required: true,
                regex:
                '^[A-Za-z][A-Za-z ]*$'
                          }">
                <input
                    id="firstName"
                    v-model="formValues.nationality"
                    class="
                      shadow
                      appearance-none
                      border
                      rounded
                      w-full
                      py-2
                      px-3
                      text-gray-700
                      leading-tight
                      focus:outline-none focus:shadow-outline
                      "
                    name
                    type="text"
                />
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
          </ValidationObserver>
          <ValidationObserver ref="subForm">
            <v-card
                class="flex flex-wrap my-2 mb-6 py-4"
                outlined
                style="background-color: whitesmoke"
            >
              <div class="w-full px-3 md:mb-0">
                <v-container>
                  <v-row>
                    <v-col cols="6" md="6" sm="6">
                      <label
                          class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                  "
                      >Year Of Education</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-autocomplete
                            v-model="studentStatusItem.yearOfEducation"
                            :elevation="1"
                            :items="YEAR_OF_EDUCATION"
                            :loading="lookupLoading"
                            dense
                            item-text="name"
                            item-value="name"
                            solo
                        >
                        </v-autocomplete>
                        <span class="text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      <label
                          class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
                      >Student Status</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-autocomplete
                            v-model="studentStatusItem.studentStatus"
                            :elevation="1"
                            :items="STUDENT_STATUSES"
                            :loading="lookupLoading"
                            dense
                            item-text="name"
                            item-value="name"
                            solo
                        ></v-autocomplete>
                        <span class="text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >GPA:
                      </label>
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                        min_gpa: 0,
                        max_gpa: 4,
                        required: true,
                      }"
                      >
                        <v-text-field
                            id="GPA"
                            v-model="studentStatusItem.gpa"
                            dense
                            name
                            solo
                            type="number"
                        ></v-text-field>
                        <span class="text-gray-600 text-xs italic text-red-700">{{
                            errors[0]
                          }}</span>
                      </validation-provider>
                      <br/>
                    </v-col>
                    <v-col cols="6" md="6" sm="8">
                      <v-btn
                          class="mt-9"
                          color="success"
                          elevation="1"
                          small
                          @click="addStudentStatus()"
                      >
                        <v-icon>mdi-plus</v-icon>
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <div class="w-full px-3 md:w-1/2 md:mb-0"></div>
              <div class="w-full md:w-1/3 px-3 md:mb-0"></div>
              <div class="w-full md:w-1/3 px-3 md:mb-0"></div>
              <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0 text-right"></div>

              <div class="w-full mb-6 md:mb-0">
                <template>
                  <v-data-table
                      :headers="headers"
                      :items="studentStatusItems"
                      class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-dialog v-model="editDialog" max-width="500px">
                        <v-card>
                          <v-card-title>
                            <span class="text-h5">Edit Student Status</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" md="4" sm="4">
                                  <v-select
                                      v-model="studentStatusItem.yearOfEducation"
                                      :elevation="1"
                                      :items="YEAR_OF_EDUCATION"
                                      :loading="lookupLoading"
                                      class="pt-5"
                                      dense
                                      item-text="name"
                                      item-value="name"
                                      solo
                                  >
                                  </v-select>
                                </v-col>
                                <v-col cols="12" md="4" sm="4">
                                  <v-select
                                      v-model="studentStatusItem.studentStatus"
                                      :elevation="1"
                                      :items="STUDENT_STATUSES"
                                      :loading="lookupLoading"
                                      class="pt-5"
                                      dense
                                      item-text="name"
                                      item-value="name"
                                      solo
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="4" sm="4">
                                  <v-text-field
                                      id="GPA"
                                      v-model="studentStatusItem.gpa"
                                      class="pt-5"
                                      dense
                                      name
                                      solo
                                      type="number"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="cancelStudentStatus"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="saveStudentStatus"
                            >
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="deleteDialog" max-width="500px">
                        <v-card>
                          <v-card-title class="text-h5"
                          >Are you sure you want to delete this
                            item?
                          </v-card-title
                          >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel
                            </v-btn
                            >
                            <v-btn
                                color="error darken-1"
                                text
                                @click="removeConfirmed"
                            >OK
                            </v-btn
                            >
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon class="mr-2" small @click="editStudentStatus(item)">
                        mdi-pencil
                      </v-icon>
                      <v-icon
                          small
                          style="color: #ff5252 !important;"
                          @click="removeStudentStatus(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </template>
              </div>
            </v-card>
          </ValidationObserver>
          <div class="flex flex-wrap my-6 mx-6 mb-6">
            <div class="w-full">
              <button
                  class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="button"
                  @click="submit()"
              >
                {{ formValues.editMode ? "Update" : "Save" }}
              </button>
            </div>
            <div class="md:w-2/3"></div>
          </div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, regex, required,} from "vee-validate/dist/rules";
import ethiopic from "ethiopic-calendar";
import {
  getDisciplines,
  getEducationalPrograms,
  getGenerationLevels,
  getLevelOfStudies,
  getRegionList,
  getStudentStatuses,
  getUniversities,
  getUniversityOwnership,
} from "@/utils/helper";
import {EducLevelEnum, YearOfEducEnum} from "@/utils/enums";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("min_gpa", {
  ...min_value,
  message: "Invalid value. GPA must be greater than 0",
});
extend("max_gpa", {
  ...max_value,
  message: "Invalid value. GPA must be less than 4",
});
extend("generic_regex", {
  ...regex,
  message: "Invalid year value. Year must have 4 digits",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("min_generic_value", {
  ...min_value,
  message: "Minimum year must be greater than 1950",
});
extend("max_generic_value", {
  ...max_value,
  message: "Maximum year must be less than or equal current year",
});
extend("min_proposed_value", {
  ...min_value,
  message: "Minimum year must be greater than or equal to proposed year",
});

export default {
  props: {
    graduates: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        firstName: null,
        fatherName: null,
        grandFatherName: null,
        sex: null,
        dateOfBirth: null,
        idNo: null,
        educationProgramId: null,
        disciplineId: null,
        levelOfStudyId: null,
        entryYear: null,
        graduationYear: null,
        expectedYear: null,
        preServiceLevel: 'GenericEntry',
        nationality: 'Ethiopia',
        editMode: false,
      },
      subformValues: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
      },
      menu: false,
      dstartMenu: false,
      today: new Date().toISOString().substr(0, 10),
      etDate: null,
      idNo: null,
      currentYear: new Date().getFullYear(),
      etCurrentYear: null,
      OWNERSHIPS: [],
      GENERATION_LEVELS: [],
      REGIONS: [],

      UNIVERSITIES: [],
      universityLoading: false,
      educationalInstId: null,

      lookupLoading: false,
      activePicker: null,
      maxBirthDate: null,
      STUDENT_STATUSES: [],
      originalData: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
      },
      studentStatusItems: [],
      studentStatusItem: {
        yearOfEducation: null,
        studentStatus: null,
        gpa: null,
      },
      editIndex: -1,
      dataTableLight: true,
      YEAR_OF_EDUCATION: [],
      EDUC_LEVEL: [],
      headers: [
        {
          text: "Year of Education",
          align: "start",
          value: "yearOfEducation",
        },
        {text: "Student Status", value: "studentStatus"},
        {text: "GPA", value: "gpa"},
        {text: "Actions", value: "actions"},
      ],
      editDialog: false,
      deleteDialog: false,
      LEVEL_OF_STUDIES: [],
      DISCIPLINES: [],
      EDUCATIONAL_PROGRAMS: [],


      programValue: null,
      allDisciplines: [],
      disciplineValue: null,
      entryYearValue: null,
      proposedYearValue: null,
    };
  },
  watch: {
    menu(val) {
      val &&
      this.$nextTick(() => (this.$refs.dateOfBirth.activePicker = "YEAR"));
    },
    options: {
      handler() {
      },
      deep: true,
    },
    programValue: function (val) {
      this.programValue = val == '' ? null : val;
      this.fetchOnFilters();
    },
    entryYearValue: function (val) {
      this.entryYearValue = val == '' ? null : val;
      this.fetchOnFilters();
    },
  },
  async created() {
    await this.initateLookups();
    this.etDate = this.convertGE(this.today);
    this.maxBirthDate = this.currentYear - 17 + "-12-31";
    this.etCurrentYear = this.convertYearGE(this.currentYear);
    if (this.graduates != null) {
      this.formValues = this.graduates;
      this.studentStatusItems = this.graduates.pre_student_statuses;
      this.formValues.editMode = true;
    }

    this.universityLoading = true;
    const univResp = await getUniversities();
    this.UNIVERSITIES = (univResp.rows && univResp.rows.length > 0) ? univResp.rows.filter((data) => {
      return data.isActive === true;
    }) : null;
    this.universityLoading = false;
  },
  methods: {
    async fetchOnFilters() {
      this.DISCIPLINES = this.allDisciplines.filter(x => x.educationProgramId == this.programValue.id);
      this.proposedYearValue = +this.entryYearValue + +this.disciplineValue?.disciplineYear;
    },
    async initateLookups() {
      this.lookupLoading = true;
      this.OWNERSHIPS = await getUniversityOwnership();
      this.GENERATION_LEVELS = await getGenerationLevels();
      this.REGIONS = await getRegionList();
      this.STUDENT_STATUSES = await getStudentStatuses();
      this.YEAR_OF_EDUCATION = await YearOfEducEnum;

      this.EDUC_LEVEL = await EducLevelEnum;
      this.LEVEL_OF_STUDIES = await getLevelOfStudies();
      this.LEVEL_OF_STUDIES = this.LEVEL_OF_STUDIES.rows.filter(x => x.level_type == 'Generic Entry');
      this.allDisciplines = await getDisciplines();
      this.allDisciplines = this.allDisciplines.rows;
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms()
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows
      this.lookupLoading = false;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    convertYearGE(val) {
      if (!val) return val;
      const year = val;
      const month = null;
      const day = null;
      let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
      return etDate.year.toString().padStart(4, "0");
    },
    async addStudentStatus() {
      if (!(await this.$refs.subForm.validate())) return;
      else {
        const isStatusExists = this.studentStatusItems.some(item => item.yearOfEducation === this.studentStatusItem.yearOfEducation);
        if (isStatusExists) {
          this.$toast.error('Student Status and gpa for this year of education already exists');
          return;
        }
        this.studentStatusItems.push(this.studentStatusItem);
        this.editIndex = this.studentStatusItems.length;
        this.studentStatusItem = {
          yearOfEducation: null,
          studentStatus: null,
          gpa: null,
        };
      }
    },
    editStudentStatus(item) {
      this.editedIndex = this.studentStatusItems.indexOf(item);
      this.studentStatusItem = Object.assign({}, item);
      this.editDialog = true;
    },
    cancelStudentStatus() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = Object.assign({}, this.originalData);
        this.editedIndex = -1;
      });
    },
    removeStudentStatus(item) {
      this.editedIndex = this.studentStatusItems.indexOf(item);
      this.studentStatusItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    removeConfirmed() {
      this.studentStatusItems.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    saveStudentStatus() {
      if (this.editedIndex > -1) {
        Object.assign(
            this.studentStatusItems[this.editedIndex],
            this.studentStatusItem
        );
      } else {
        this.studentStatusItems.push(this.studentStatusItem);
      }
      this.closeDialog();
    },
    closeDialog() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = Object.assign({}, this.originalData);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        this.studentStatusItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async submit() {
      this.formValues.studentStatuses = this.studentStatusItems;
      this.formValues.educationProgramId = this.programValue.id;
      this.formValues.disciplineId = this.disciplineValue.id;
      this.formValues.entryYear = this.entryYearValue;
      this.formValues.expectedYear = this.proposedYearValue;

      if (!(await this.$refs.mainForm.validate())) return;
      this.$emit("registerOrUpdateGenericEntries", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
